import { AddressBooksQuery } from '../../models/address-books-query';
import { AddressBook } from '../../models/address-book';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface AddressBooksTableState {
    query: AddressBooksQuery;
    page: AddressBook[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
}

export const selectAddressBooksTableState = (state: AppState) => state.addressBooksTable;

export const selectAddressBooksTableQuery = createSelector(selectAddressBooksTableState,
    (state: AddressBooksTableState) => state.query);

export const selectAddressBooksTablePage = createSelector(selectAddressBooksTableState,
    (state: AddressBooksTableState) => state.page);

export const selectAddressBooksTableBusy = createSelector(selectAddressBooksTableState,
    (state: AddressBooksTableState) => state.busy);

export const selectAddressBooksTableCount = createSelector(selectAddressBooksTableState,
    (state: AddressBooksTableState) => state.totalCount);

export const selectAddressBooksTableSelection = createSelector(selectAddressBooksTableState,
    (state: AddressBooksTableState) => state.selection);
